/*
///// HOW TO USE:

{% render 'load-more' id: 'paginate-previous', paginatePart: paginate.previous, target: targetId, position: 'prepend', label: 'load more' %}

<div id='{{ targetId }}'>  </div>

{% render 'load-more' id: 'paginate-next', paginatePart: paginate.next, target: targetId, position: 'append', label: 'load more' %}

*/

class LoadMore extends HTMLElement {
	constructor() {
		super();
        const self = this
		this.sumbitButton = this.querySelector("[type='submit']");
		this.sumbitButton.addEventListener("click", this.onSubmitHandler.bind(this));

        if(this.dataset.position == 'append') {
            this.targetElement = this
    
            this.observerOptions = {
                root: null,         // Use the browser viewport
                rootMargin: '0px',  // No extra offset margins
                threshold: 0      // Trigger when 10% of the element is visible
            };
    
            this.observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        self.onSubmitHandler()
                    // Optional: Stop observing if you only need to trigger this once (e.g., lazy loading)
                    // observer.unobserve(entry.target); 
                    }
                });
            }, this.observerOptions);
            
            this.observer.observe(this);
        }
	}

	updateUrl(url) {
		window.history.replaceState({}, "", url);
	}

	onSubmitHandler() {
        this.sumbitButton.setAttribute('disabled', '')
        this.sumbitButton.classList.add('loading')

		const sectionId = this.dataset.section;

		fetch(`${this.dataset.url}&section_id=${sectionId}`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(this.dataset.target);
				const source = html.getElementById(this.dataset.target);

				if (source && destination) {
					switch (this.dataset.position) {
						case "prepend":
							source.innerHTML += destination.innerHTML;
							destination.innerHTML = source.innerHTML;
							break;
						case "append":
							destination.innerHTML += source.innerHTML;
							break;
						default:
							break;
					}
				}
                this.sumbitButton.removeAttribute('disabled')
                this.sumbitButton.classList.remove('loading')
				this.updateUrl(this.dataset.url);

				const loadMore = html.getElementById(this.id);
				if (loadMore) {
					this.dataset.url = loadMore.dataset.url;
				} else {
					this.remove();
				}
                if(typeof restoreCheckoutButton != 'undefined') {
                    restoreCheckoutButton()
                }
			});
	}
}
customElements.define("load-more", LoadMore);